import type { FC } from "react";
import type { ConnectionCategory } from "../../moment/hooks/use-connections";
import { ConnectionSelectController } from "./connection-select-controller";

export const ConnectionSelect: FC<{
  connectionCategories: ConnectionCategory[];
  disabled?: boolean;
}> = ({ connectionCategories }) => {
  return (
    <>
      <h3>Send to the connection</h3>
      <ConnectionSelectController connectionCategories={connectionCategories} />
    </>
  );
};
